module.exports = __webpack_public_path__ + "static/media/LockInActive.4653c674.svg";